module.exports = __webpack_public_path__ + "public/img/tipbdh.bedb2488.png";